module.exports = __webpack_public_path__ + "static/media/Tooth_icon_fc4491.2baae852.svg";